module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"candidates":"Candidates","tariffInactiveTitle":"Your tariff is inactive.","tariffInactiveText":"To gain access to all the functions of your tariff, you need to make a payment.","tariffInactiveButton":"Upgrade plan"}}')
  delete Component.options._Ctor
}
